import BaseContainer from './Container';

// EXPORT
export const Container = BaseContainer;
export type { ContainerProps } from './Container.interface';
